<template>
  <div class="c-table-cell">
    <div v-if="cell === 'employee'" class="c-table-cell__wrapper cell-employee">
      <router-link :to="{ name: 'personal-employee-summary', params: { id: data.id } }" class="cell-employee__name">
        {{ data.fullName }}
      </router-link>

      <div class="cell-employee__info">
        <div
          v-if="data.docsTrouble"
          class="cell-employee__docs-trouble"
          @click="$router.push({ name: 'personal-employee-summary', params: { id: data.id } })"
        >
          <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125"
              stroke="#FF238D"
              stroke-width="2"
            />
          </svg>

          <div class="cell-employee__docs-trouble-tooltip">
            {{ data.docsTrouble }}
          </div>
        </div>

        <div
          v-if="data.rankStatus"
          class="cell-employee__rank-status"
          :class="`cell-employee__rank-status_${data.rankStatus}`"
        >
          <svg width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 1V11M5 11L9 7M5 11L1 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <div class="cell-employee__rank-status-tooltip">
            {{ rankStatusRecommendation }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="cell === 'deposit-state'"
      class="c-table-cell__wrapper cell-deposit-state"
      :class="`cell-deposit-state_${data.color}`"
    >
      <div class="cell-deposit-state__label">{{ data.text }}</div>
    </div>

    <component :is="cellComponent" :data="data" />
  </div>
</template>

<script>
import CreationDateCell from "./candidates/creation-date-cell";
import FullnameCell from "./candidates/fullname-cell";
import SourceCell from "./candidates/source-cell";
import StatusCell from "./candidates/status-cell";
import ReferralCell from "./candidates/referral-cell";
import ViolationFullNameCell from "./violations/fullname-cell";
import ViolationDeadlineCell from "./violations/deadline-cell";
import FineOrBonusFullNameCell from "./fines-and-bonuses/fullname-cell";
import FineOrBonusDeadlineCell from "./fines-and-bonuses/deadline-cell";
import FineOrBonusAmountCell from "./fines-and-bonuses/amount-cell";

const cellComponents = {
  candidateState: CreationDateCell,
  candidate: FullnameCell,
  source: SourceCell,
  candidateStatus: StatusCell,
  candidateReferral: ReferralCell,
  violationFullNameCell: ViolationFullNameCell,
  violationDeadlineCell: ViolationDeadlineCell,
  fineOrBonusDeadlineCell: FineOrBonusDeadlineCell,
  fineOrBonusFullNameCell: FineOrBonusFullNameCell,
  fineOrBonusAmountCell: FineOrBonusAmountCell,
};

export default {
  name: "c-table-cell",
  components: {
    CreationDateCell,
    FullnameCell,
    SourceCell,
    StatusCell,
    ReferralCell,
    ViolationFullNameCell,
  },
  props: ["cell", "data"],
  data() {
    return {
      baseUrl: window.location.origin,
    };
  },

  computed: {
    rankStatusRecommendation() {
      if (this.data.rankStatus === "up") {
        return `Рекомендуем повысить разряд до ${this.data.rankValue}`;
      }
      if (this.data.rankStatus === "down") {
        return `Рекомендуем понизить разряд до ${this.data.rankValue}`;
      }
      return "";
    },
    cellComponent() {
      return cellComponents[this.cell];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table-cell {
  width: 100%;
  height: 100%;
  line-height: 13px;

  &__wrapper {
    font-size: 13px;
  }

  .cell-employee {
    padding: 10px;
    display: flex;
    //overflow: hidden;
    justify-content: space-between;
    align-items: center;

    &__name {
      color: $color-primary;
      text-decoration: none;
      font-size: 13px;
      line-height: 14px;
    }

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      margin-left: 20px;
    }

    &__docs-trouble,
    &__rank-status {
      position: relative;
      display: flex;
      justify-content: center;
      cursor: pointer;

      &-tooltip {
        position: absolute;
        background: white;
        font-size: 11px;
        box-shadow: $box-shadow-tooltip;
        padding: 6px 10px;
        border-radius: $border-radius-tooltip;
        bottom: 0;
        right: -10px;
        max-width: 200px;
        width: max-content;
        text-align: center;
        line-height: 16px;
        opacity: 0;
        visibility: hidden;
        transition: 0.2s;
        font-weight: 400;
        z-index: 100;
      }
    }

    &__docs-trouble {
      &:hover {
        .cell-employee__docs-trouble-tooltip {
          visibility: visible;
          opacity: 1;
          bottom: 20px;
        }
      }
    }

    &__docs-trouble + .cell-employee__rank-status {
      margin-top: 20px;
    }

    &__rank-status {
      &_up {
        svg {
          stroke: $color-green;
          transform: rotate(180deg);
        }
      }

      &_down {
        svg {
          stroke: $color-secondary;
        }
      }

      &:hover {
        .cell-employee__rank-status-tooltip {
          visibility: visible;
          opacity: 1;
          bottom: 16px;
        }
      }
    }
  }

  .cell-deposit-state {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 13px;

    &_none {
      background: $color-bg;
    }

    &_error {
      background: $color-bg-secondary;
    }

    &_success {
      background: $color-bg-success;
    }

    &_warning {
      background: $color-bg-warning;
    }
  }
}
.h-auto {
  height: auto;
}
</style>
